import * as React from "react";
import { mergeRefs } from "../mergeRefs/index";
function useMergeRefs(...args) {
  return React.useMemo(
    () => mergeRefs(...args),
    // eslint-disable-next-line
    [...args]
  );
}
export {
  useMergeRefs
};
//# sourceMappingURL=index.js.map
